import { render, staticRenderFns } from "./ExpandableOrderDetails.vue?vue&type=template&id=779dad71&scoped=true&"
import script from "./ExpandableOrderDetails.vue?vue&type=script&lang=js&"
export * from "./ExpandableOrderDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779dad71",
  null
  
)

export default component.exports